import React, {useContext, useEffect, useReducer, useState} from 'react';
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {useParams} from "react-router-dom";
import {AnagraficaContext, AppContext} from "../../../../App";
import HideAppBar from "../../../widgets/header/HideAppBar";
import {Container} from "@mui/material";
import Grid from "@mui/material/Grid";
import {initTamponiState, TAMPONI_INITIAL_STATE, TamponiReducer} from "../../../../reducers/TamponiReducer";
import {getPrenotazioneById} from "../../../../services/TamponiServices";
import { Skeleton } from '@mui/material';
import {getAnagraficaById} from "../../../../services/AnagraficaServices";
import {setOpenSnackbar} from "../../../../services/AppServices";
import DiarioPaziente from "../../../widgets/diary/DiarioPaziente";
import PrenotazioneDetailCard from "./PrenotazioneDetailCard";
import StoricoPrenotazione from "./StoricoPrenotazione";
import AnagraficaTamponeCard from "./AnagraficaTamponeCard";

const PrenotazioneDetailPage = () => {
	const classes = BaseStyle();
	let {id} = useParams();
	const appContext = useContext(AppContext);
	const anagraficaContext = useContext(AnagraficaContext);
	const [tamponiState, tamponiDispatch] = useReducer(TamponiReducer, TAMPONI_INITIAL_STATE, initTamponiState);
	const [submitGetPrenotazione, setSubmitGetPrenotazione] = useState(false);

	useEffect(() => {
		setSubmitGetPrenotazione(true);
		getPrenotazioneById(id, tamponiDispatch);
	}, [id, tamponiDispatch])

	useEffect(() => {
		if (submitGetPrenotazione && !tamponiState.loadingGetPrenotazione && tamponiState.errorGetPrenotazione === "") {
			setSubmitGetPrenotazione(false);
			getAnagraficaById(tamponiState.prenotazione?.soggetto?.idSoggetto, anagraficaContext.dispatch);
		} else if (submitGetPrenotazione && !tamponiState.loadingGetPrenotazione && tamponiState.errorGetPrenotazione !== "") {
			setSubmitGetPrenotazione(false);
			setOpenSnackbar("error", tamponiState.errorGetPrenotazione, appContext.dispatch);
		}
	}, [submitGetPrenotazione, tamponiState.loadingGetPrenotazione, tamponiState.errorGetPrenotazione, appContext.dispatch, tamponiState.prenotazione, anagraficaContext.dispatch])

	return (
		<React.Fragment>
			<main className={classes.main}>
				<HideAppBar title={"Prenotazione " + id}/>
				<Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
					<Grid container spacing={3} >

						<Grid item xs={12} md={6}>
							<Grid container spacing={3} style={{
								maxHeight: "92vh",
								overflowY: "auto",
								overflowX: "hidden",
								scrollbarWidth: "none"
							}}>
								<Grid item xs={12}>
									{
										tamponiState.loadingGetPrenotazione ? <Skeleton/> :
											tamponiState.errorGetPrenotazione !== "" ? "Err..." :
												<AnagraficaTamponeCard anagrafica={tamponiState.prenotazione.soggetto}/>
									}
								</Grid>
								<Grid item xs={12}>
									{
										tamponiState.loadingGetPrenotazione ? <Skeleton/> :
											tamponiState.errorGetPrenotazione !== "" ? "Err..." :
												<DiarioPaziente idSoggetto={tamponiState.prenotazione?.soggetto?.idSoggetto}/>
									}
								</Grid>
							</Grid>
						</Grid>

						<Grid item xs={12} md={6}>
							<Grid container spacing={3} style={{
								maxHeight: "92vh",
								overflowY: "auto",
								overflowX: "hidden",
								scrollbarWidth: "none"
							}}>
								<Grid item xs={12}>
									{
										tamponiState.loadingGetPrenotazione ? <Skeleton/> :
											tamponiState.errorGetPrenotazione !== "" ? "Err..." :
												<PrenotazioneDetailCard prenotazione={tamponiState.prenotazione} dispatch={tamponiDispatch}
												                        state={tamponiState}/>
									}
								</Grid>
								<Grid item xs={12}>
									{
										tamponiState.loadingGetPrenotazione ? <Skeleton/> :
											tamponiState.errorGetPrenotazione !== "" ? "Err..." :
												<StoricoPrenotazione/>
									}
								</Grid>
							</Grid>
						</Grid>

					</Grid>
				</Container>
			</main>
		</React.Fragment>
	);
}

export default React.memo(PrenotazioneDetailPage)
